import { formatApiDate, ISO_DATE_FORMAT } from '~/shared/lib/date'
import { TaskFormDraft } from './taskTypes'
import { ProvidersCasesFromCategoryPreviewRetrieveResponse } from '@fireflyhealth/api'

type TaskPreview = ProvidersCasesFromCategoryPreviewRetrieveResponse['task_previews'][number]

export const mapPreviewTasksToTasks = (
  taskPreviews: TaskPreview[],
  options: { defaultAssigneeGroup: number },
): TaskFormDraft[] => {
  return taskPreviews.map(taskPreview => {
    return {
      title: taskPreview.title,
      due_date: formatApiDate(taskPreview.due_date, ISO_DATE_FORMAT) ?? '',
      owner_group: taskPreview.assignee_pk ?? options.defaultAssigneeGroup,
      is_complete: false,
      priority: taskPreview.priority || 0,
      task_template_pk: taskPreview.task_template_pk,
    }
  })
}
